<template>
  <div class="inno-date-picker">
    <div class="inno-date-input-wrapper">
      <input 
        type="date" 
        class="real-hidden-input" 
        :value="internalValue" 
        :max="maxDate" 
        @change="handleFinalChange"
        ref="dateInput"
      />
      
      <div class="visual-display-box">
        <span>{{ internalValue || placeholder }}</span>
        <span class="calendar-icon">📅</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InnoDateTimePicker',
  props: {
    value: String,
    modelValue: String,
    placeholder: {
      type: String,
      default: '請選擇日期'
    },
    maxDate: {
      type: String,
      default: ''
    }
  },
  computed: {
    internalValue() {
      return (this.modelValue !== undefined) ? this.modelValue : this.value;
    },
    // 將顯示文字美化：把 T 換成空格，例如 2026-04-29T14:00 變成 2026-04-29 14:00
    /*displayValue() {
      if (!this.internalValue) return '';
      return this.internalValue.replace('T', ' ');
    }*/
  },
  methods: {
    handleFinalChange(e) {
      const newValue = e.target.value;
      this.$emit('input', newValue);
      this.$emit('update:modelValue', newValue);
      this.$emit('change', newValue);
    }
  }
};
</script>

<style scoped>
.inno-date-picker {
  position: relative;
  width: 100%;
  max-width: 280px;
  font-size: 14px;
}

.inno-date-input-wrapper {
  position: relative;
  height: 38px; /* 統一高度 */
}

/* 視覺顯示框：放在底層 */
.visual-display-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  z-index: 1; /* 底層 */
}

/* 真實的 Input：放在頂層，完全透明 */
.real-hidden-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 2; /* 頂層，確保點擊到它 */
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
}

/* 關鍵優化：擴張 Chrome 內建日期按鈕的點擊範圍至整個 Input */
.real-hidden-input::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  cursor: pointer;
  /* 即使透明，依然讓它撐滿，這在某些瀏覽器是叫起選單的關鍵 */
}

/* Hover 效果：透過 CSS 選擇器讓上層 Input 被 hover 時，下層 Box 變色 */
.real-hidden-input:hover + .visual-display-box {
  border-color: #409eff;
}

.calendar-icon {
  font-size: 14px;
  color: #c0c4cc;
}
</style>